import { createAsyncThunk } from '@reduxjs/toolkit'
import { instance } from '../api/api'

export type StrType = {
  companyId: number
  companyName: string
  averageCheck: number
  loadingPercent: number
  rank: number
}

export const getStr = createAsyncThunk(
  'str/getStr',
  async ({ token }: { token: string }, thunkAPI) => {
    try {
      const response = await instance.get<StrType[]>('str', {
        headers: { authorization: `Bearer ${token}` },
      })

      return response.data
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return thunkAPI.rejectWithValue('Unauthorized')
      }
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || 'Ошибка при получении STR',
      )
    }
  },
)
